<!--
 * @Author: ken yang
 * @Date: 2023-02-28 16:27:41
 * @LastEditTime: 2026-04-09
 * @LastEditors: Codex
 * @Description:
 * @FilePath: /uexch_pc/src/components/empty/ListEmpty.vue
-->
<template>
  <Column class="ListEmpty w-100b pt-100px select-none" x="c" y="c">
    <img
      :src="emptyImage"
      :style="imageStyle"
      class="bg-center bg-no-repeat bg-size-100% object-contain"
      alt="empty"
      draggable="false"
    >
    <span class="m-t-10 text-12px lh-normal text-center text-cccand9b80">
      {{ text ?? $t('public.emptyData') }}
    </span>
  </Column>
</template>

<script setup>
import emptyLightImage from '@/image/empty/no-list.png'
import emptyDarkImage from '@/image/empty/no-list-dark.webp'
import { Column } from '@/layout/index.js'

const configStore = useConfigStore()

const props = defineProps({
  size: {
    default: 68,
  },
  name: {
    default: 'popular',
  },
  text: {},
  supportDark: {
    type: Boolean,
    default: false,
  },
})

const emptyImage = $computed(() => {
  return props.supportDark && configStore.theme === 'dark' ? emptyDarkImage : emptyLightImage
})

const imageStyle = $computed(() => {
  const size = Number(props.size) || 68
  return {
    width: `${size}px`,
    height: `${size * 1.1764}px`,
  }
})
</script>
